@if (hasAccess(item.permission) && (depth === 0 || (depth > 0 && isExpanded))) {
	<a
		mat-list-item
		[ngStyle]="{ 'padding-left': depth * 12 + (isExpanded ? 0 : 10) + 'px' }"
		(click)="onItemSelected($event, item)"
		[id]="item.icon"
		[ngClass]="{
			'sidenav-center': !isExpanded,
			'sidenav-expanded': isExpanded,
			active: item.path ? router.isActive(item.path, true) : false,
			notSelectable: depth > 0,
		}">
		<span matListItemIcon>
			<mat-icon mat-list-icon svgIcon="{{ item.icon }}"></mat-icon>
		</span>
		@if (isExpanded) {
			<span matListItemLine>
				{{ (item.forceTranslateKey ? item.forceTranslateKey : 'insights.sidebar.administration.' + item.label.toLowerCase()) | translate }}
			</span>
		}
	</a>
}

@if (expanded) {
	<div>
		@for (child of item.children; track child) {
			<app-menu-list-item [item]="child" [depth]="depth + 1" [isExpanded]="isExpanded"></app-menu-list-item>
		}
	</div>
}
